document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const count = event.cartData?.item_count;
      if (typeof count !== 'number') return;
      document.querySelectorAll('.vo-cart-count').forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
        badge.closest('a')?.setAttribute('aria-label', `Cart, ${count} items`);
      });
    });

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const current = document.querySelector('.vo-offers');
      const updated = event.data?.html?.querySelector('.vo-offers');
      if (current && updated) current.replaceWith(updated.cloneNode(true));
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-manual-checkout]');
    if (!button || button.disabled) return;
    event.preventDefault();

    let lines = [];
    try {
      lines = JSON.parse(button.dataset.lines || '[]');
    } catch (_error) {
      return;
    }
    if (!Array.isArray(lines) || lines.length === 0) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const originalLabel = button.textContent;
    button.textContent = 'Opening secure checkout…';

    const form = document.createElement('form');
    form.method = 'post';
    form.action = 'https://pg.komalfashion.in/manual-checkout.php';
    form.hidden = true;
    const append = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(value);
      form.appendChild(input);
    };
    append('action', 'start');
    append('store', button.dataset.store || 'vape-org-in');
    lines.forEach((line) => {
      append('line_id[]', line.id);
      append('line_quantity[]', line.quantity);
    });
    document.body.appendChild(form);
    form.submit();

    window.setTimeout(() => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }, 5000);
  });
});
